import React, { useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { Button } from 'primereact/button';
// eslint-disable-next-line max-len
import AccommodationBlockingViolation from '../../../shared/accommodation-blocking-violation/accommodation-blocking-violation';
import {
  deleteAccommodationBlocking,
  getAccommodationBlockings,
  GENERIC_FAILURE_MESSAGE,
} from '../../../../store/actions';
import styles from './accommodation-blocking-delete.module.scss';

function parsePositiveIntegerId(rawId: string | undefined): number | undefined {
  if (!rawId || !/^\d+$/.test(rawId)) {
    return undefined;
  }

  const id = Number(rawId);
  return id > 0 ? id : undefined;
}

function AccommodationBlockingDelete() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { accounts } = useMsal();
  const { id: rawId } = useParams<{ id?: string }>();
  const id = parsePositiveIntegerId(rawId);

  const [violations, setViolations] = useState<string[]>([]);
  const [isDeleting, setIsDeleting] = useState(false);

  if (id === undefined) {
    // eslint-disable-next-line unicorn/no-null
    return <Navigate replace to="/accommodation-blocking/overview" />;
  }

  const handleCancel = () => {
    navigate('/accommodation-blocking/overview');
  };

  const handleConfirm = async () => {
    setViolations([]);
    setIsDeleting(true);

    try {
      const result = await dispatch(deleteAccommodationBlocking(id, accounts[0]?.username ?? ''));

      if (result.status === 'deleted') {
        // Overview only re-fetches when its list is empty (see accommodation-blocking-overview.tsx),
        // so without this the deleted row would still show on return. Dispatch a refresh (not
        // awaited, so navigation isn't delayed) the same way the Save flow does.
        dispatch(getAccommodationBlockings());
        navigate('/accommodation-blocking/overview');
        return;
      }

      if (result.status === 'rejected') {
        setViolations(result.messages);
        return;
      }

      setViolations([GENERIC_FAILURE_MESSAGE]);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className={styles.accommodationBlockingDelete}>
      <h1 className={styles.heading}>Delete Accommodation Blocking</h1>
      <p>Do you want to delete the accommodation blocking with id {id}?</p>

      <AccommodationBlockingViolation violations={violations} />

      <div className={styles.actions}>
        <Button label="Confirm" onClick={handleConfirm} loading={isDeleting} disabled={isDeleting} />
        <Button label="Cancel" outlined onClick={handleCancel} disabled={isDeleting} />
      </div>
    </div>
  );
}

export default AccommodationBlockingDelete;
